export const adjustPhone = (phoneValue) => (phoneValue.startsWith('+') ? phoneValue : `+${phoneValue}`);
